"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSvg;
exports.externalBasePath = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("../Box"));
var _packageVersion = _interopRequireDefault(require("../constants/package-version"));
var _useThemeOptions = _interopRequireDefault(require("../styles/useThemeOptions/useThemeOptions"));
// We upload images to s3 and use a proxy to avoid cross-domain issues.
// So, in production, we point to the s3 path as if it was local.
const externalBasePath = exports.externalBasePath = `/dscl/${_packageVersion.default}/images`;
const isDev = process.env.NODE_ENV !== 'production';
/**
 * **❗️ DEPRECATED**: Use icons from `@busbud/horizon` or add a new one to the library.
 *
 * Creates a React functional component that renders an SVG element.
 */
function createSvg(_ref) {
  let {
    inlineSvg = 'svg',
    width,
    height,
    name,
    path
  } = _ref;
  const svgPath = path || `${externalBasePath}/${name}.svg#root`;
  const Component = props => {
    const {
      useExternalSvgResources
    } = (0, _useThemeOptions.default)();
    const SvgElement = useExternalSvgResources ? 'svg' : inlineSvg;
    const SvgComponent = props => /*#__PURE__*/_react.default.createElement(SvgElement, (0, _extends2.default)({
      height: height,
      width: width,
      "aria-hidden": true
    }, props));
    return /*#__PURE__*/_react.default.createElement(_Box.default, (0, _extends2.default)({
      component: SvgComponent
    }, props), useExternalSvgResources && /*#__PURE__*/_react.default.createElement("use", {
      href: svgPath
    }));
  };
  if (isDev) {
    Component.displayName = `DsIcon${name}`;
  }
  return Component;
}